/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { MenuAnchorEl } from "../../../../../shared";
import Menu from "../../../../Menu/Menu";
import { useStyles } from "../../../styles";
import { DIALOG_NAMES } from "../../../types/enums";

import SettingsContent from "./SettingsContent/SettingsContent";

interface SettingsMenuDesktopProps {
  isMobile: boolean;
  anchorEl: MenuAnchorEl;
  close: () => void;
  openDialog: (name: DIALOG_NAMES) => void;
}

const SettingsMenuDesktop = ({
  isMobile,
  anchorEl,
  close,
  openDialog
}: SettingsMenuDesktopProps) => {
  const { settingsDesktopMenu } = useStyles();

  return (
    <Menu
      data-testid="settings-desktop-menu"
      open={Boolean(anchorEl)}
      onClose={close}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      slotProps={{ list: { disableListWrap: true } }}
      css={css(settingsDesktopMenu)}
    >
      <SettingsContent
        isMobile={isMobile}
        closeMenu={close}
        openDialog={openDialog}
      />
    </Menu>
  );
};

export default SettingsMenuDesktop;
